import * as React from "react"
import { connect } from "react-redux"
import PasswordResetRequestForm from "./PasswordResetRequestForm"
import { passwordResetReqeustFormSubmitted } from "./actions"
import { isStateLoading } from "../../filters/selectors"
import { getCurrentPath } from "../../router/selectors"
import UnauthorizedContentBox from "../../common/UnauthorizedContentBox"
import PasswordResetRequestActionButtons from "./PasswordResetRequestActionButtons"
import * as Color from "../../../constants/colors"

type Props = {
    isProcessing: boolean
    currentPath: Record<string, any>
    onSubmit: (email: string) => void
}

const PasswordResetRequestComponent = (props: Props) => {
    const error = props.currentPath && props.currentPath.query.error
    const success = props.currentPath && props.currentPath.query.success

    return (
        <UnauthorizedContentBox>
            {success ? (
                <React.Fragment>
                    <h1
                        style={{
                            textAlign: "center",
                            fontWeight: 700,
                            fontSize: "1.5rem",
                            color: "#66717d",
                        }}>
                        Password Reset Link Sent
                    </h1>
                    <p
                        style={{
                            color: Color.Black,
                            textAlign: "center",
                            fontSize: "16px",
                            marginBottom: "1rem",
                        }}>
                        Please check your email
                    </p>
                    <PasswordResetRequestActionButtons />
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <h1
                        style={{
                            textAlign: "center",
                            fontWeight: 700,
                            fontSize: "1.5rem",
                            color: "#66717d",
                        }}>
                        Request Password Reset
                    </h1>
                    {error && (
                        <div
                            style={{
                                color: Color.Red,
                                textAlign: "center",
                                marginBottom: "1rem",
                            }}>
                            Something went wrong, please try again.
                        </div>
                    )}
                    {/* @ts-expect-error */}
                    <PasswordResetRequestForm onSubmit={props.onSubmit} isProcessing={props.isProcessing} />
                    <PasswordResetRequestActionButtons />
                </React.Fragment>
            )}
        </UnauthorizedContentBox>
    )
}

const mapStateToProps = state => ({
    currentPath: getCurrentPath(state),
    isProcessing: isStateLoading(state, "password-reset-request"),
})

const mapDispatchToProps = {
    onSubmit: passwordResetReqeustFormSubmitted,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(PasswordResetRequestComponent)
